import React, {memo} from 'react'
import cx from 'classnames'

/* Components */
import HbImageView from '../../../../components/HbImage/view/HbImageView'

/* Constants */
import {DAVINCI_EVENT_NAMES} from '../../../../modules/analytics/davinci/davinciConstants'

/* Styles */
import s from './product-badges.scss'

const SAFETY_BADGE_NAME = 'Ürün güvenliği bilgileri';

const ProductBadges = memo(({className, badges, sku, pageTypeForDavinci}) => {
  if (!badges?.length) {
    return null
  }

  const handleOnProductSafetyInformationClick = () => {
    window.HbEventBus.emit('storefront.productSafety.active', true)
  }

  return (
    <section
      className={cx(s.root, className)}
      data-test-id={'product-badges'}>
      <div className={s.title} data-test-id='product-badges-title'>
        {'Ek bilgiler'}
      </div>
      <div className={s.badgeContainer} data-test-id='product-badges-wrapper'>
        {
          badges?.map((badge) => {
            const BadgeElement = badge?.link ? 'a' : 'span'
            const isSafetyBadge = badge.name === SAFETY_BADGE_NAME

            return (
              <BadgeElement
                key={badge?.id}
                href={!isSafetyBadge && badge.link}
                onClick={isSafetyBadge && handleOnProductSafetyInformationClick}
                className={s.badgeItem}
                data-hbus={JSON.stringify({
                  events: {
                    click: ['davinci'],
                  },
                  data: {
                    eventNameForView: DAVINCI_EVENT_NAMES.BANNER_VIEW,
                    eventNameForClick: DAVINCI_EVENT_NAMES.BANNER_CLICK,
                    pageType: pageTypeForDavinci,
                    pageValue: sku,
                    id: `${badge?.id}`,
                    placement: 'vinyet',
                    bucket_name: badge?.name,
                    bucket_position: badge?.order,
                    position: `${badge?.order}`,
                  },
                  type: 'bannerDetails',
                })}>
                <HbImageView
                  className={s.badgeImage}
                  shouldLoadEagerly={false}
                  image={{
                    src: badge?.imageUrl,
                    alt: badge?.name,
                  }}/>
              </BadgeElement>
            )
          })
        }
      </div>
    </section>
  )
})

export default ProductBadges
